import { ID } from '../../../util/ID';
import React, { FC, memo, useMemo } from 'react';
import clsx from 'clsx';
import { LabelContainer, SpanCheckMark, SpanLabel } from './styles';

type TProps = {
  name: string;
  value?: boolean;
  indeterminate?: boolean;
  label?: string;
  autoTestAttr?: string;
  className?: string;
  disabled?: boolean;
  onChange?: (value: boolean) => void;
};

const FnCheckbox: FC<TProps> = ({
  label,
  autoTestAttr = '',
  value = false,
  onChange = null,
  className = '',
  name,
  disabled = false,
  indeterminate = false
}) => {
  const id = useMemo(() => ID(), []);

  return (
    <LabelContainer htmlFor={`${name}-${id}`} className={clsx(className, 'fn-checkbox', { active: value, indeterminate, disabled, className })}>
      <SpanCheckMark className="fn-checkbox-mark" indeterminate={Number(indeterminate)} />
      <input
        data-auto-test={autoTestAttr}
        type="checkbox"
        id={`${name}-${id}`}
        value={label}
        checked={value}
        disabled={disabled}
        onChange={() => (onChange ? onChange(indeterminate ? indeterminate : !value) : null)}
      />
      {label ? <SpanLabel className="fn-checkbox-label">{label}</SpanLabel> : null}
    </LabelContainer>
  );
};

export default memo(FnCheckbox);
